import { ArrowUpRight } from "lucide-react";

// Partner logo (on a white chip so it reads in light and dark themes) plus "In partnership with X" link.
// Renders nothing when the office has no partner.
export const OfficePartner = ({ office, className = "" }) =>
  office?.partner ? (
    <span className={`block ${className}`} data-testid={`office-partner-${office.id}`}>
      {office.partner.logo && (
        <a
          href={office.partner.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${office.partner.name} website`}
          className="mb-3 inline-flex h-12 items-center border border-black/5 bg-white px-3 transition-transform duration-300 hover:-translate-y-0.5"
          data-testid={`office-partner-logo-${office.id}`}
        >
          <img src={office.partner.logo} alt={`${office.partner.name} logo`} loading="lazy" className="h-7 w-auto max-w-[150px] object-contain" />
        </a>
      )}
      <span className="block">
        In partnership with{" "}
        <a
          href={office.partner.href}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-0.5 font-medium text-accent underline-offset-4 hover:underline"
          data-testid={`office-partner-link-${office.id}`}
        >
          {office.partner.name}
          <ArrowUpRight className="h-3.5 w-3.5" />
        </a>
      </span>
    </span>
  ) : null;
